import { ref } from 'vue';
import { defineStore } from 'pinia';
import { AppContext } from '@web/enums/AppContext';

export const useAppContextStore = defineStore('appContext', () => {
  const entry = ref<AppContext | null>(null);

  function setEntry(value: AppContext) {
    if (entry.value !== null) {
      throw new Error('Entry should only be set once.');
    }
    entry.value = value;
  }

  return {
    entry,
    setEntry,
  };
});
